import type { ILimitationProps } from '../../types/limitation';

import { useLimitation } from './useLimitation';

interface ILimitPathAnalysisResult {
  isEnabled: boolean;
}

export const useLimitPathAnalysis = ({ planKey }: ILimitationProps): ILimitPathAnalysisResult => {
  const { getLimitByPlanKey } = useLimitation();

  const planConditions = getLimitByPlanKey(planKey)?.analytic?.pathAnalysis;

  const isEnabled = planConditions?.enable ?? false;

  return {
    isEnabled,
  };
};
